// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Accessibility = require("./Particle_Accessibility.bs.js");

var ariaHidden = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

exports.ariaHidden = ariaHidden;
/* ariaHidden Not a pure module */
